import css from 'styled-jsx/css';

const styles = css.global`.survey-list{width:100%;display:grid;grid-template-columns:repeat(auto-fit, minmax(290px, 1fr));gap:20px}`;

export default styles;